<template>
    <div class="div-textarea-container" ref="newTextarea">
        <div
            contenteditable="true"
            ref="textareaInput"
            :id="contentId"
            :placeholder="placeholderTxt"
            class="textarea-value scroll-tracker"
            @click="inputClick($event)"
            @focus="isLocked = true"
            @blur="isLocked = false"
            @keydown.delete="handleDelete($event)"
            @mousemove="mousemoveHandle($event)"
            @mouseout="mouseoutHandle($event)"
            @mouseup="selectHandle"
            @paste="pasteHandle"
            :style="{ background: bgColor, color: baseColor }"
        ></div>
        <span class="textarea-tip">{{ wordCount }}/{{ maxlength }}</span>
        <div class="mousemove-detail" ref="previewTextarea" :style="positionStyle">{{ moveDetail }}</div>
    </div>
</template>

<script>
import { uniqueId } from "@/views/zhiji/js/common/util.js";

export default {
    name: "TextEditor",
    props: ["dataValue", "placeholder", "tag", "maxlength", "bgColor", "baseColor", "cmdParam", "cmdTagParam"],
    data() {
        return {
            showHover: false,
            isLocked: false,
            currentTagId: null,
            contentId: `text${uniqueId()}`,
            savedRange: "",
            moveDetail: "",
            positionStyle: "",
            wordCount: 0,
            oldText: "",
            isOnComposition: false,
            cmdData: [...(this.cmdParam || [])], // 画像参数
            cmdTagData: [...(this.cmdTagParam || [])] // 画像标签
        };
    },
    mounted() {
        let text = this.dataValue || "";
        text = text.replace(/\r\n/g, "<br>");
        text = text.replace(/\n/g, "<br>");
        this.$refs.textareaInput.innerHTML = `${text}<br>`; // 结尾增加一个br
        window.document.addEventListener("click", this.windowClick);
        this.wordCount = this.$refs.textareaInput.textContent.length;

        let dom = this.$refs.textareaInput;
        dom.addEventListener(
            "compositionstart",
            () => {
                this.isOnComposition = true;
            },
            false
        );
        dom.addEventListener(
            "compositionend",
            () => {
                this.isOnComposition = false;
                this.handleInput();
            },
            false
        );
        dom.addEventListener(
            "input",
            () => {
                if (this.isOnComposition) {
                    return;
                }
                this.handleInput();
            },
            false
        );
    },
    destroyed() {
        document.removeEventListener("click", this.windowClick);
    },
    computed: {
        placeholderTxt() {
            return this.placeholder ? this.placeholder : this.$t("zhiji.answer.textWidget.enterTextTip");
        }
    },
    watch: {
        dataValue(val) {
            if (!this.isLocked) {
                this.$refs.textareaInput.innerHTML = `${val}<br>`;
            }
        }
    },
    methods: {
        windowClick(event) {
            if (!this.$el.contains(event.target)) {
                this.saveCurrentRange();
            }
        },
        saveCurrentRange() {
            // 保存当前光标与选区
            const range = this.getRange();
            if (range && range.commonAncestorContainer.ownerDocument.activeElement.id === this.contentId) {
                this.savedRange = range;
                this.$emit("selectedText", range.toString());
            } else {
                this.$emit("selectedText", "");
            }
            // 触发添加画像参数浮框
            this.isShowPortrait();
        },
        selectHandle() {
            this.saveCurrentRange();
            // 取消高亮
            if (!this.savedRange.commonAncestorContainer) return;
            let selectedEle = this.savedRange.commonAncestorContainer.parentElement;
            if (selectedEle.nodeName == "P" && selectedEle.getAttribute("type") == "highlight") {
                this.$emit("clickLinkHigh", {
                    id: selectedEle.id,
                    type: selectedEle.getAttribute("type")
                });
            }
        },
        // 去除粘贴内容样式
        pasteHandle(e) {
            e.preventDefault();
            const text = e.clipboardData.getData("text/plain");
            document.execCommand("insertText", false, text.replace(/\r\n/g, "\n"));
        },
        updateData(ele) {
            let data = this.htmlToServerData(ele);
            this.$emit("input", {
                linkWord: data.linkWord,
                text: data.text,
                value: ele.innerHTML,
                wordCount: this.wordCount,
                newText: ele.innerText.replace(/\s+$/g, ""), // 没有组装的text
                cmd: data.cmd,
                cmdTagClassify: data.cmdTagClassify
            });
        },
        addEmoji(emoji) {
            let node = document.createElement("i");
            node.innerText = emoji;
            this.insertNode(node);
            this.setCursorToEnd();
            this.wordCount = this.$refs.textareaInput.textContent.length;
        },
        handleInput() {
            this.saveCurrentRange();

            let contentStr = this.$refs.textareaInput.textContent;
            let lengthStr = contentStr.length;
            if (lengthStr > this.maxlength) {
                this.$refs.textareaInput.innerHTML = this.oldText;
                if (this.wordCount < this.maxlength) {
                    let nowStr = this.$refs.textareaInput.innerHTML;
                    let lastEl = nowStr.substring(nowStr.length - 6, nowStr.length);
                    let subStr = contentStr.substring(this.wordCount, this.maxlength);
                    if (lastEl == "</div>") {
                        this.$refs.textareaInput.innerHTML = nowStr.slice(0, nowStr.length - 10) + subStr;
                    } else {
                        this.$refs.textareaInput.innerHTML += subStr;
                    }
                }
                this.setCursorToEnd();
                this.wordCount = this.maxlength;
            } else {
                this.wordCount = contentStr.length;
            }
            this.oldText = this.$refs.textareaInput.innerHTML;
            this.updateData(this.$refs.textareaInput);
        },
        addLink(text) {
            let node = document.createElement(this.tag);
            node.innerText = text.word;
            node.id = uniqueId();
            node.style = `color:` + text.urlType.color;
            node.setAttribute("contenteditable", "false");
            node.setAttribute("data-url", text.url);
            node.setAttribute("type", "link");
            node.setAttribute("data-type", text.urlType.colorType);
            this.insertNode(node);
        },
        addQuestion(text) {
            let node = document.createElement(this.tag);
            node.innerText = text.word;
            node.id = uniqueId();
            node.style = `color:` + text.wordColor;
            node.setAttribute("type", "question");
            node.setAttribute("data-question", text.questionData.question);
            node.setAttribute("data-questionId", text.questionData.questionId);
            node.setAttribute("contenteditable", "false");
            this.insertNode(node);
        },
        addHihtColor(text) {
            let node = document.createElement("p");
            node.innerText = text.word;
            node.id = uniqueId();
            node.style = `color:` + text.color;
            node.setAttribute("type", "highlight");
            this.insertNode(node);
        },
        // 是否触发添加画像参数浮框
        isShowPortrait() {
            const range = this.savedRange;
            const content = range ? range.commonAncestorContainer.textContent : "";
            const rect = range && range.getBoundingClientRect();
            const self = this;
            // 光标前一个字符为'{'触发画像参数、 '['触发画像标签
            const contentStart = content[range.startOffset - 1];
            if ((range.collapsed && contentStart === "{") || (range.collapsed && contentStart === "[")) {
                rect.left &&
                    rect.top &&
                    this.$store.dispatch("zhiji/showModal", {
                        type: "AddPortraitEdit",
                        data: {
                            type: contentStart === "{" ? "param" : "tag",
                            position: {
                                left: `${rect.left}px`,
                                top: `${rect.top + 15}px`
                            },
                            callback: data => {
                                self.addPortrait(data, "input");
                            }
                        }
                    });
            } else {
                // 关闭添加画像参数浮框
                this.$store.state.zhiji.modalState.modals.some(item => {
                    if (item.type === "AddPortraitEdit") {
                        this.$store.dispatch("zhiji/hideModal", "AddPortraitEdit");
                    }
                });
            }
        },
        // 添加画像参数
        addPortrait(text, type) {
            const handlers = {
                param: this.paramPortraitHandle, // 画像参数
                tag: this.tagPortraitHandle // 画像标签
            };

            handlers[text.type].call(null, text, type);

            this.savedRange = "";
            this.wordCount = this.$refs.textareaInput.textContent.length;
        },

        // 画像参数
        paramPortraitHandle(text, type) {
            const str = type ? `${text.key}}` : `{${text.key}}`;
            const node = document.createTextNode(str);
            const isExist = this.cmdData.some(item => item.paramId == text.value);
            !isExist &&
                this.cmdData.push({
                    key: text.key,
                    paramId: text.value && text.value.toString(),
                    source: "sdk" // 暂只支持来源为sdk
                });
            this.insertNode(node);
        },
        // 画像标签
        tagPortraitHandle(text, type) {
            const str = type ? `${text.key}]` : `[${text.key}]`;
            const node = document.createTextNode(str);
            const isExist = this.cmdTagData.some(item => item.paramId == text.value && item.key == text.key);
            !isExist &&
                this.cmdTagData.push({
                    key: text.key,
                    paramId: text.value && text.value.toString(),
                    source: "sdk" // 暂只支持来源为sdk
                });
            this.insertNode(node);
        },
        updateLink(text) {
            let target = document.getElementById(text.id);
            target.style = `color:` + text.urlType.color;
            target.setAttribute("data-url", text.url);
            target.setAttribute("data-type", text.urlType.colorType);
            this.updateData(this.$refs.textareaInput);
        },
        updateQuestion(text) {
            let target = document.getElementById(text.id);
            target.setAttribute("data-question", text.questionData.question);
            target.setAttribute("data-questionId", text.questionData.questionId);
            this.updateData(this.$refs.textareaInput);
        },
        updateHihtColor(text) {
            let target = document.getElementById(text.id);
            target.style = "";
            target.replaceWith(target.innerText);
            this.updateData(this.$refs.textareaInput);
        },
        deleteLink(text) {
            let target = document.getElementById(text.id);
            target.replaceWith(text.word);
            this.updateData(this.$refs.textareaInput);
        },
        insertNode(node) {
            if (this.savedRange.commonAncestorContainer == undefined) return;
            this.savedRange.deleteContents();
            this.savedRange.insertNode(node);
            // 更新双向绑定数据
            this.updateData(this.$refs.textareaInput);
            this.oldText = this.$refs.textareaInput.innerHTML;
        },
        inputClick(event) {
            this.isLocked = true;
            const TAG_NAME = event.target.nodeName;
            let clickType = event.target.getAttribute("type");
            clickType && this.clickTextHandle(clickType, event);
            if (TAG_NAME === this.tag.toUpperCase()) {
                // 点击模版标签时，记录id
                this.currentTagId = event.target.id;
            } else if (this.currentTagId) {
                this.currentTagId = null;
            } else {
                this.currentTagId = null;
            }
        },
        mousemoveHandle(event) {
            const TAG_NAME = event.target.nodeName;
            if (TAG_NAME === this.tag.toUpperCase()) {
                let clickType = event.target.getAttribute("type");
                clickType === "question"
                    ? (this.moveDetail = event.target.getAttribute("data-question"))
                    : (this.moveDetail = event.target.getAttribute("data-url"));
                // 获取当前位置
                this.$refs.previewTextarea.textContent && (this.positionStyle = this.getPosition(event.target));
            }
        },
        mouseoutHandle(event) {
            const TAG_NAME = event.target.nodeName;
            if (TAG_NAME === this.tag.toUpperCase()) {
                this.moveDetail = "";
                this.positionStyle = "";
            }
        },
        getPosition(target) {
            let position = {};
            position = target.getBoundingClientRect();
            let left = position.left;
            let top = position.top + position.height;
            return {
                left: left + "px",
                top: top + "px"
            };
        },
        clickTextHandle(type, data) {
            if (type == "highlight") return;
            const handlers = {
                question: this.updateQuestionHandle,
                link: this.updateLinkHandle
            };

            handlers[type].call(null, data);
            this.updateData(this.$refs.textareaInput);
        },
        updateQuestionHandle(event) {
            this.$emit("clickLinkQuestion", {
                id: event.target.id,
                type: event.target.getAttribute("type"),
                text: event.target.innerText,
                question: event.target.getAttribute("data-question"),
                questionId: event.target.getAttribute("data-questionid")
            });
        },
        updateLinkHandle(event) {
            this.$emit("clickLinkWord", {
                id: event.target.id,
                type: event.target.getAttribute("type"),
                text: event.target.innerText,
                url: event.target.getAttribute("data-url"),
                colorType: event.target.getAttribute("data-type")
            });
        },
        handleDelete(event) {
            if (this.currentTagId) {
                // 若已选中模版标签，直接删除dom节点
                let t = document.getElementById(this.currentTagId);
                this.$refs.textareaInput.removeChild(t);
                this.currentTagId = null;
                event.preventDefault();
                this.updateData(this.$refs.textareaInput);
            }
        },
        getRange() {
            if (window.getSelection) {
                let sel = window.getSelection();
                if (sel.rangeCount > 0) {
                    return sel.getRangeAt(0);
                }
            } else if (document.selection) {
                // IE兼容
                return document.selection.createRange();
            }
            return null;
        },
        // 将光标移至文本最后
        setCursorToEnd() {
            let el = this.$refs.textareaInput;
            if (window.getSelection) {
                el.focus();
                let range = window.getSelection();
                range.selectAllChildren(el);
                range.collapseToEnd();
            } else {
                let range = document.selection.createRange();
                range.moveToElementText(el);
                range.collapse(false);
                range.select();
            }
        },
        // 恢复光标选值范围
        restoreSelection(selectedRange) {
            let selection = window.getSelection();
            if (!selectedRange) {
                selection.removeAllRanges();
                this.$emit("selectedText", "");
                return;
            }
            if (selectedRange) {
                try {
                    selection.removeAllRanges(); //清空所有range对象
                } catch (e) {
                    // IE
                    document.body.createTextRange().select();
                    document.selection.empty();
                }
            }
            selection.addRange(selectedRange);
        },
        htmlToServerData(dom) {
            let linkWord = [];
            let text = "";
            let cmd = []; // 画像参数
            let cmdTagClassify = []; // 画像参数
            // eslint-disable-next-line
            const params = dom.innerText.match(/[^{\}]+(?=})/g) || [];
            // eslint-disable-next-line
            const tags = dom.innerText.match(/[^[\]]+(?=])/g) || [];
            cmd = this.cmdData.filter(item => params.indexOf(item.key) > -1);
            cmdTagClassify = this.cmdTagData.filter(item => tags.indexOf(item.key) > -1);
            dom.childNodes.forEach(item => {
                if (item.id && (item.nodeName == "SPAN" || item.nodeName == "P") && item.textContent) {
                    const type = item.attributes.type.value;
                    let dataObj = {
                        id: item.id,
                        word: type == "link" ? item.textContent.replace(/^(\s|【)?|(\s|】)?$/g, "") : item.textContent,
                        type: type,
                        questionId: item.getAttribute("data-questionid"),
                        url: item.getAttribute("data-url"),
                        color: item.style.color
                    };

                    if (dataObj.type == "link") {
                        let linkType = item.getAttribute("data-type");
                        linkType == "innerColor" ? (dataObj.linkType = "custom_page") : (dataObj.linkType = "new_page");
                    } else if (dataObj.type == "question") {
                        dataObj.question = item.getAttribute("data-question");
                    }
                    linkWord.push(dataObj);
                    text += "{{" + item.id + "}}";
                } else if (item.nodeName == "DIV") {
                    if (item.textContent) {
                        let child = this.htmlToServerData(item);
                        text === "" ? (text += child.text + "\n") : (text += "\n" + child.text);
                        linkWord = [...linkWord, ...child.linkWord];
                    } else {
                        text += "\n";
                    }
                } else if (item.nodeName == "BR") {
                    text += "\n";
                } else {
                    text += item.textContent;
                }
            });

            text = text.replace(/\n$/g, ""); // 去除文本结尾原本存在的换行

            return {
                text,
                linkWord,
                cmd,
                cmdTagClassify
            };
        }
    }
};
</script>
<style lang="scss">
.div-textarea-container {
    width: 100%;
    position: relative;
    padding: 8px;
    background: #fafbfd;
    border-radius: 4px;
    box-sizing: border-box;

    span[type="question"],
    span[type="link"] {
        color: #26a2ff;
        padding: 0 1px;
        white-space: nowrap;
        cursor: pointer;
        -webkit-user-modify: read-only !important;
    }
    .textarea-value {
        display: inline-block;
        width: 100%;
        height: 100%;
        margin-left: auto;
        margin-right: auto;
        font-size: 12px;
        line-height: 21px;
        word-wrap: break-word;
        overflow-x: hidden;
        overflow-y: auto;
        background: #fafbfd;
        outline: none;
        user-select: text;
        font: 400 13.3333px Arial;
        &:empty:before {
            content: attr(placeholder);
            color: #a0a0a0;
            font-size: 12px;
        }
        &:focus {
            outline: none !important;
        }

        p {
            display: inline !important;
        }
        i,
        span {
            font-style: normal;
            user-select: none;
            -webkit-user-select: none;
        }
        span[data-type="innerColor"]::before,
        span[data-type="outColor"]::before {
            content: "【";
        }
        span[data-type="innerColor"]::after,
        span[data-type="outColor"]::after {
            content: "】";
        }
    }
    .mousemove-detail {
        background: #333333;
        border-radius: 2px;
        font-size: 12px;
        padding: 6px;
        color: #fff;
        max-width: 450px;
        position: fixed;
        top: -9999px;
        left: -9999px;
    }

    .textarea-tip {
        position: absolute;
        bottom: 4px;
        right: 8px;
        font-size: 12px;
        color: #9b9ba3;
    }
}
</style>
